<template>
  <v-layout v-if="showBanner" wrap full-width>
    <v-flex xs12 md7 class="pay-at-close-banner">
      <div class="pay-at-close-banner-content">
        <span class="pay-at-close-banner-content-title">
          {{ title }}
        </span>
        <span class="pay-at-close-banner-content-description">
          {{ description }}
        </span>
      </div>
      <img
        src="https://s3.amazonaws.com/spectora-shared/pay-at-close-minimum-limit-banner.png"
        class="pay-at-close-banner-image"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['total'],

  computed: {
    ...mapState('inspection', ['company']),

    canUsePayAtClose() {
      return this.company.attributes.pay_at_close_eligibility
        .can_use_pay_at_close
    },

    payAtCloseMinimumTransactionThreshold() {
      return this.company.attributes.pay_at_close_eligibility
        .pay_at_close_minimum_transaction_threshold
    },

    payAtCloseMaximumTransactionThreshold() {
      return this.company.attributes.pay_at_close_eligibility
        .pay_at_close_maximum_transaction_threshold
    },

    showPayAtCloseEligibilityBanner() {
      return (
        this.total >= this.payAtCloseMinimumTransactionThreshold &&
        this.total <= this.payAtCloseMaximumTransactionThreshold
      )
    },

    showPayAtCloseMinimumLimitBanner() {
      const totalIsBelowMinimumTransactionThreshold =
        this.total < this.payAtCloseMinimumTransactionThreshold

      return (
        this.company.attributes.pay_at_close_eligibility
          .show_pay_at_close_minimum_limit_banner &&
        totalIsBelowMinimumTransactionThreshold
      )
    },

    amountNeededForMinimum() {
      return (
        this.company.attributes.currency_sym +
        (
          this.company.attributes.pay_at_close_eligibility
            .pay_at_close_minimum_transaction_threshold - this.total
        ).toFixed(2)
      )
    },

    title() {
      if (this.showPayAtCloseEligibilityBanner) {
        return 'You qualify for Pay at Close!'
      } else if (this.showPayAtCloseMinimumLimitBanner) {
        return 'Want to Pay at Close?'
      }

      return ''
    },

    description() {
      if (this.showPayAtCloseEligibilityBanner) {
        return 'To enable this option, complete the opt-in process in the client portal once your inspection is scheduled. Then you can defer payment until closing.'
      } else if (this.showPayAtCloseMinimumLimitBanner) {
        return `Add ${this.amountNeededForMinimum} in services to qualify for rolling payment into your closing costs–it's one less upfront expense and provides you the flexibility to add additional services as needed.`
      }

      return ''
    },

    showBanner() {
      if (!this.canUsePayAtClose) return false

      return (
        this.showPayAtCloseMinimumLimitBanner ||
        this.showPayAtCloseEligibilityBanner
      )
    },
  },
}
</script>

<style lang="scss">
.pay-at-close-banner {
  display: flex;
  background-color: #f6fafe;
  border-radius: 6px;

  @media only screen and (max-width: 660px) {
    flex-flow: column-reverse;
  }

  &-content {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    padding: 24px;
    gap: 8px;

    &-title {
      font-size: 21px;
      font-weight: 700;
      color: #212731;
    }

    &-description {
      font-size: 14px;
      font-weight: 400;
      color: #1f2937;
    }
  }

  &-image {
    object-fit: cover;
    height: 173px;

    @media only screen and (max-width: 660px) {
      border-top-right-radius: 6px;
      border-top-left-radius: 6px;
    }

    @media only screen and (min-width: 660px) {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }
}
</style>
